'use client';

import { useEffect, useState } from 'react';

import { useBreakpoint } from '@eliadmin/core/src/hooks/use-breakpoint';
import { useLocalePathname } from '@eliadmin/core/src/hooks/use-locale-pathname';

/**
 * Open state of a mobile overlay (the drawer, the categories view) tied to the page: it is open „on“
 * a pathname, so a navigation (also browser back) closes it in the same render, and it is then
 * forgotten – going back to that page, or a tablet turned to ≥ 1024 px and back, must not reopen it.
 */
export function useRouteOpen() {
  const pathname = useLocalePathname();
  const isDesktop = useBreakpoint('lg');
  const [openOn, setOpenOn] = useState<string | null>(null);

  useEffect(() => {
    setOpenOn(null);
  }, [pathname, isDesktop]);

  return {
    pathname,
    isOpen: openOn === pathname && !isDesktop,
    setOpen: (open: boolean) => setOpenOn(open ? pathname : null),
  };
}
